"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCacheRegionKey = exports.getInvalidationRegionsFiltersKey = exports.getCacheRegionsKey = exports.getCacheLocationKey = exports.getInvalidationLocationsFiltersKey = exports.getCacheLocationsKey = void 0;
const keyGenerator_1 = require("./keyGenerator");
// ===== LOCATIONS =====
const getCacheLocationsKey = (filter, sortingData, distanceCoordinates) => {
    const params = { ...filter, ...sortingData, ...distanceCoordinates };
    const key = (0, keyGenerator_1.getCacheKeyForObject)('LOC', 'getLocations', params);
    return key;
};
exports.getCacheLocationsKey = getCacheLocationsKey;
const getInvalidationLocationsFiltersKey = () => 'CA_IN_LOC_getLocations_0';
exports.getInvalidationLocationsFiltersKey = getInvalidationLocationsFiltersKey;
const getCacheLocationKey = (id) => `CA_LOC_getLocation_${id}`;
exports.getCacheLocationKey = getCacheLocationKey;
// ===== REGIONS =====
const getCacheRegionsKey = (filter, sortingData, distanceCoordinates) => {
    const params = { ...filter, ...sortingData, ...distanceCoordinates };
    const key = (0, keyGenerator_1.getCacheKeyForObject)('REG', 'getRegions', params);
    return key;
};
exports.getCacheRegionsKey = getCacheRegionsKey;
const getInvalidationRegionsFiltersKey = () => 'CA_IN_REG_getRegions_0';
exports.getInvalidationRegionsFiltersKey = getInvalidationRegionsFiltersKey;
const getCacheRegionKey = (id) => `CA_REG_getRegion_${id}`;
exports.getCacheRegionKey = getCacheRegionKey;
